import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const PLATFORM_VIDEO_REPORT_ID = `platform${VIDEO_CAMPAIGN_SUFFIX}`;
